import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetConflictOfInterestListByAppGuid = createAsyncThunk(
  "GetConflictOfInterestListByAppGuid/GetConflictOfInterestListByAppGuid",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ConflictsOfInterestAndResearchEthics/GetConflictsOfInterestAndResearchEthicsListByAppGuid",
        {
          applicationInformationId: applicationInformationId,
        }
      );

      const data = response.data.result; // Assuming response has a "data" field

      const yesNoList = {};
      data.forEach((marks) => {
        if (!yesNoList[marks.questionsGroupingName]) {
          yesNoList[marks.questionsGroupingName] = {
            GroupingName: "",
            row: "",
            value: [],
          };
        }
        yesNoList[marks.questionsGroupingName].GroupingName =
          marks.questionsGroupingName;
        yesNoList[marks.questionsGroupingName].row = marks.rowSorting;
        yesNoList[marks.questionsGroupingName].value.push(marks);
      });
      return yesNoList;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateConflictOfInterest = createAsyncThunk(
  "ValidateConflictOfInterest/ValidateConflictOfInterest",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ConflictsOfInterestAndResearchEthics/ValidateConflictsOfInterestAndResearchEthics",
        {
          applicationInformationId: applicationInformationId,
        }
      );

      const data = response.data.result; 
      
      // if (response.data.success === true) {
      //   const arrayValidate = response.data.result.map((ele, ind) => {
      //     console.log(ele.message, "validation");
      //     return ele.message;
      //   });

      //   return arrayValidate; 
      // }
      return data; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateConflictOfInterestList = createAsyncThunk(
  "UpdateConflictOfInterestList/UpdateConflictOfInterestList",
  async (param, { rejectWithValue }) => {
    console.log(param, "param");

    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ConflictsOfInterestAndResearchEthics/UpdateConflictsOfInterestAndResearchEthics",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaaaaaaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ConflictOfInterest = createSlice({
  name: "ConflictOfInterest",
  initialState: {
    ConflictOfInterest: [],
    loadingConflictOfInterest: false,
    errorConflictOfInterest: null,
    //------------------update-------------------
    ConflictOfInterestUpdate: [],
    loadingConflictOfInterestUpdate: false,
    errorConflictOfInterestUpdate: null,
    //--------------------------------------
    ConflictOfInterestValidate: [],
    loadingConflictOfInterestValidate: false,
    errorConflictOfInterestValidate: null,
  },
  reducers: { setConflictOfInterest: (state, action) => {
    state.ConflictOfInterest = action.payload;
  },},
  extraReducers: (builder) => {
    builder
      .addCase(GetConflictOfInterestListByAppGuid.pending, (state, action) => {
        state.loadingConflictOfInterest = true;
        state.ConflictOfInterest = action.payload;
        state.errorConflictOfInterest = null;
      })
      .addCase(
        GetConflictOfInterestListByAppGuid.fulfilled,
        (state, action) => {
          state.loadingConflictOfInterest = false;
          state.ConflictOfInterest = action.payload;
        }
      )
      .addCase(GetConflictOfInterestListByAppGuid.rejected, (state, action) => {
        state.loadingConflictOfInterest = false;
        state.errorConflictOfInterest = action.payload;
      })
      //---------------------update------------------------
      .addCase(UpdateConflictOfInterestList.pending, (state, action) => {
        state.loadingConflictOfInterestUpdate = true;
        state.ConflictOfInterestUpdate = action.payload;
        state.errorConflictOfInterestUpdate = null;
      })
      .addCase(UpdateConflictOfInterestList.fulfilled, (state, action) => {
        state.loadingConflictOfInterestUpdate = false;
        state.ConflictOfInterestUpdate = action.payload;
      })
      .addCase(UpdateConflictOfInterestList.rejected, (state, action) => {
        state.loadingConflictOfInterestUpdate = false;
        state.errorConflictOfInterestUpdate = action.payload;
      })
      //----------------------------Validation--------------------------------
      .addCase(ValidateConflictOfInterest.pending, (state, action) => {
        state.loadingConflictOfInterestValidate = true;
        state.ConflictOfInterestValidate = action.payload;
        state.errorConflictOfInterest = null;
      })
      .addCase(ValidateConflictOfInterest.fulfilled, (state, action) => {
        state.loadingConflictOfInterestValidate = false;
        state.ConflictOfInterestValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateConflictOfInterest.rejected, (state, action) => {
        state.loadingConflictOfInterestValidate = false;
        state.errorConflictOfInterest = action.payload;
      });
  },
});
export const { setConflictOfInterest} = ConflictOfInterest.actions;

export default ConflictOfInterest.reducer;
